import React from 'react';
import { useDevice } from '../../../redux/commander/hooks/useDevice';
import { useControlUnitsById } from '../../../redux/controlUnit/hooks/useControlUnitsById';
import _ from 'lodash';
import { Box, CircularProgress, Divider } from '@mui/material';

import DeckControlUnitOven from './DeckControlUnitOven';
import useWatchError from '../../../handlingErrors/useWatchError';

interface DeckOvenProps {
  deviceId: string;
  isLoadingComposableDevice: boolean;
}
function DeckOven(props: DeckOvenProps) {
  const { deviceId: deviceId, isLoadingComposableDevice } = props;
  /** Init Groups */
  const {
    data: device,
    error: devicesError,
    isLoading: loadingDevices,
  } = useDevice(deviceId);

  const { data: controlUnits, error: controlUnitsError } = useControlUnitsById({
    deviceId: deviceId,
    hideCommander: true,
  });
  useWatchError(controlUnitsError || devicesError);
  // the Commander should only have 1 controlUnit that is the oven ControlUnit
  // FIXME: for some reason there is a bug that show uninstalled controlUnits so I will choose the last one
  const ovenControlUnit = _.last(controlUnits);

  return (
    <Box width={1}>
      {ovenControlUnit ? (
        <DeckControlUnitOven
          deviceName={device?.name}
          controlUnit={ovenControlUnit}
          deviceId={deviceId}
        />
      ) : null}
    </Box>
  );
}

export default DeckOven;
